import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dateAgo",
  standalone: true
})
export class DateAgoPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      const seconds: number = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 300)
        // less than 300 seconds ago will show as 'Just now'
        return "New";
      const intervals: {
        [key: string]: number;
      } = {
        day: 86400,
        min: 60,
        sec: 1
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (i == "min" && counter > 31) {
          return "Today";
        }
        if (counter > 0) {
          return counter + " " + i + " ago"; // singular (1 day ago)
        }
      }
    }
    return value;
  }
}
